module.exports = __webpack_public_path__ + "img/logo-left.479366db.png";